import { render, staticRenderFns } from "./CustAddMain.vue?vue&type=template&id=76788b46&scoped=true&"
import script from "./CustAddMain.vue?vue&type=script&lang=js&"
export * from "./CustAddMain.vue?vue&type=script&lang=js&"
import style0 from "./CustAddMain.vue?vue&type=style&index=0&id=76788b46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76788b46",
  null
  
)

export default component.exports